import { RiskRating } from "~/graphql/supergraphEnums";
import {
  type PaymentAccountInput,
  type RiskRating as RiskRatingType,
} from "~/graphql/supergraphTypes";
import { CompliancePaymentAccountType } from "../BeneficiarySummary/BeneficiaryCellRenderer/BeneficiaryView/types";
import { PaymentInstructionFormValues } from "../types";

const getOverriddenRiskRating = (
  oldRiskRating?: RiskRatingType | null,
  newRiskRating?: RiskRatingType | null,
) => {
  if (newRiskRating == RiskRating.None) {
    if (oldRiskRating && oldRiskRating != RiskRating.None) {
      return newRiskRating;
    }
  } else {
    return newRiskRating;
  }
};

export const prepareUpdateRequestPayload = (
  values: PaymentInstructionFormValues,
  initialValues: PaymentInstructionFormValues,
  compliancePaymentAccount?: CompliancePaymentAccountType,
): PaymentAccountInput => {
  return {
    profileId: values.accountHolderId ?? compliancePaymentAccount?.profileId ?? -1,
    providerName: values.bankName ?? initialValues.bankName ?? "",
    bankCountry: values.country ?? initialValues.country ?? "",
    payeeName:
      (values.accountNameMatches ?? initialValues.accountNameMatches) === "no"
        ? (values.bankAccountName ?? initialValues.bankAccountName)
        : null,
    mismatchReason:
      (values.accountNameMatches ?? initialValues.accountNameMatches) === "no"
        ? (values.explanation ?? initialValues.explanation)
        : null,
    overriddenRiskRating: getOverriddenRiskRating(
      compliancePaymentAccount?.riskRating?.overriddenRating,
      values.riskRating,
    ),
  };
};
